import { RootState } from '../index';
import { StoreStatus } from '../../core/types/common.types';
import { PickListAliquot } from '../../core/api/lab.types';

export const shipmentPickListHasErrorSelector = (state: RootState): boolean =>
  state.shipmentPickList.errors && state.shipmentPickList.errors ? true : false;

export const shipmentPickListIsBusySelector = (state: RootState): boolean =>
  state.shipmentPickList.status === StoreStatus.BUSY;

export const shipmentPickListResponseSelector = (state: RootState): PickListAliquot[] | null =>
  state.shipmentPickList.response || null;
